module.exports = __webpack_public_path__ + "img/terracenew_box21.59a3a1cd.jpg";